export default "__VITE_ASSET__Clvv0OHx__"